import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getUserId, planetPost, planetUpload } from "../../api/planetApi";

export default function PlanetBottleCreatePage() {
  const userId = getUserId();
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [deliverMode, setDeliverMode] = useState("random");
  const [destCity, setDestCity] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  if (!userId) {
    return (
      <p className="text-sm">
        请先 <Link to="/login" className="text-teal-700 underline">登录</Link>
      </p>
    );
  }

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    setMsg("");
    try {
      const data = await planetUpload(userId, file);
      setImagePath(data.url);
      setMsg("手写信已上传");
    } catch (err) {
      setMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    try {
      const data = await planetPost("/bottles", {
        user_id: userId,
        content,
        image_path: imagePath,
        bottle_type: imagePath ? "handwritten" : "text",
        deliver_mode: deliverMode,
        dest_city: destCity,
      });
      navigate(`/planet/bottles/${data.bottle.id}`);
    } catch (err) {
      setMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="max-w-lg space-y-5 bg-white border rounded-xl p-5">
      <h2 className="text-lg font-medium text-teal-950">投递漂流瓶</h2>
      <p className="text-sm text-slate-500">
        提交后进入审核；本地演示默认自动过审并匹配收件人（非精准婚恋匹配）。正式环境可在后台关闭自动过审。请勿留联系方式或违规内容。
      </p>

      <label className="block text-sm">
        <span className="text-slate-500">正文</span>
        <textarea
          className="mt-1 w-full border rounded-lg px-3 py-2 min-h-[120px]"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          maxLength={2000}
          placeholder="写给未知收件人的话…"
        />
      </label>

      <label className="block text-sm">
        <span className="text-slate-500">手写信图片（可选）</span>
        <input type="file" accept="image/*" className="mt-1 block w-full text-sm" onChange={onFile} />
        {imagePath && <p className="text-xs text-teal-700 mt-1">已上传：{imagePath}</p>}
      </label>

      <fieldset className="text-sm space-y-2">
        <legend className="text-slate-500 mb-1">投递方式</legend>
        {[
          ["random", "随机（种子城开关开启时）"],
          ["nearby", "附近（同城）"],
          ["city", "指定城市"],
        ].map(([v, label]) => (
          <label key={v} className="flex items-center gap-2">
            <input
              type="radio"
              name="mode"
              checked={deliverMode === v}
              onChange={() => setDeliverMode(v)}
            />
            {label}
          </label>
        ))}
      </fieldset>

      {(deliverMode === "city" || deliverMode === "nearby") && (
        <label className="block text-sm">
          <span className="text-slate-500">目标城市{deliverMode === "nearby" ? "（可留空，用你的城市）" : ""}</span>
          <input
            className="mt-1 w-full border rounded-lg px-3 py-2"
            value={destCity}
            onChange={(e) => setDestCity(e.target.value)}
            placeholder="如：上海"
          />
        </label>
      )}

      {msg && <p className="text-sm text-teal-800">{msg}</p>}

      <div className="flex gap-3">
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 rounded-lg bg-teal-700 text-white text-sm disabled:opacity-50"
        >
          {loading ? "提交中…" : "提交审核"}
        </button>
        <Link to="/planet/bottles" className="px-4 py-2 rounded-lg border text-sm">
          取消
        </Link>
      </div>
    </form>
  );
}
